import { render, staticRenderFns } from "./ExcellentSelect.vue?vue&type=template&id=827f6b30&scoped=true"
import script from "./ExcellentSelect.vue?vue&type=script&lang=js"
export * from "./ExcellentSelect.vue?vue&type=script&lang=js"
import style0 from "./ExcellentSelect.vue?vue&type=style&index=0&id=827f6b30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827f6b30",
  null
  
)

export default component.exports